<div class="appContentsContainer">
  <form class="formGroup container halfForm wrapHalfRows">
    <div class="pageTitle">Datos generales</div>

    <div class="halfGroup">
      <div class="collapsibleTitle pageTitle">
        <div class="collapseButtonContainer">
          <button
            type="button"
            *ngIf="!sectionHidden.peticion"
            class="submitSearchButton"
            (click)="sectionHidden.peticion = !sectionHidden.peticion"
          >
            <em class="fas fa-angle-up"></em>
          </button>

          <button
            type="button"
            *ngIf="sectionHidden.peticion"
            class="submitSearchButton"
            (click)="sectionHidden.peticion = !sectionHidden.peticion"
          >
            <em class="fas fa-angle-down"></em>
          </button>

          <div class="pageTitle collapsibleTitle">
            <div class="title halfTitle">Datos de solicitud</div>
          </div>
        </div>
      </div>

      <div *ngIf="!sectionHidden.peticion">
        <app-form-fields
          #solicitud
          *ngIf="fieldsSolicitud"
          [fields]="fieldsSolicitud"
        ></app-form-fields>
        <div class="consultaEditarButtonGroup marginButtonPrecio reponsiveWidth" *ngIf="this.isPrecioEdit()">
          <div class="buttonContainer justifyButtonPrecio">
            <div class="buttonPrecio">
              <div class="middleButtonAceptar m-0">
                <button class="formButton" type="button" (click)="onSavePrecio()">
                  {{ "commons.save" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="halfGroup">
      <div class="collapsibleTitle pageTitle">
        <div class="collapseButtonContainer">
          <button
            type="button"
            *ngIf="!sectionHidden.vehiculo"
            class="submitSearchButton"
            (click)="sectionHidden.vehiculo = !sectionHidden.vehiculo"
          >
            <em class="fas fa-angle-up"></em>
          </button>

          <button
            type="button"
            *ngIf="sectionHidden.vehiculo"
            class="submitSearchButton"
            (click)="sectionHidden.vehiculo = !sectionHidden.vehiculo"
          >
            <em class="fas fa-angle-down"></em>
          </button>

          <div class="pageTitle collapsibleTitle">
            <div class="title halfTitle">Datos de vehículo</div>
          </div>
        </div>
      </div>

      <div *ngIf="!sectionHidden.vehiculo">
        <div
          *ngIf="
            coc && coc.peTcertificado != 'CM' && coc.peTcertificado != 'CML'
          "
        >
          <app-form-fields
            #vehiculo
            *ngIf="fieldsVehiculo"
            [fields]="fieldsVehiculo"
          ></app-form-fields>
        </div>

        <div
          class="bastidoresCoC"
          *ngIf="
            coc && (coc.peTcertificado == 'CM' || coc.peTcertificado == 'CML')
          "
        >
          <table>
            <caption style="display: none">
              Texto prueba
            </caption>

            <thead>
              <th>Número de bastidor</th>
              <th>Fecha primera matriculación</th>
            </thead>

            <tbody>
              <ng-container *ngFor="let item of listCoCBastidores">
                <tr>
                  <td>{{ item.bcBastidor }}</td>
                  <td>{{ item.bcFechaPriMatric | date : "dd/MM/yyyy" }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="fullGroup">
      <div class="collapsibleTitle pageTitle">
        <div class="collapseButtonContainer">
          <button
            type="button"
            *ngIf="!sectionHidden.obs"
            class="submitSearchButton"
            (click)="sectionHidden.obs = !sectionHidden.obs"
          >
            <em class="fas fa-angle-up"></em>
          </button>

          <button
            type="button"
            *ngIf="sectionHidden.obs"
            class="submitSearchButton"
            (click)="sectionHidden.obs = !sectionHidden.obs"
          >
            <em class="fas fa-angle-down"></em>
          </button>

          <div class="pageTitle collapsibleTitle">
            <div class="title halfTitle">Comentario / Observaciones</div>
          </div>
        </div>
      </div>

      <div *ngIf="!sectionHidden.obs" class="reponsiveWidthComentarios">
        <app-form-fields
          #comentario
          *ngIf="fieldsComentario"
          [fields]="fieldsComentario"
        ></app-form-fields>
      </div>
    </div>

    <div class="fullGroup">
      <div class="collapsibleTitle pageTitle">
        <div class="collapseButtonContainer pb-0">
          <button
            type="button"
            *ngIf="!sectionHidden.concreto"
            class="submitSearchButton"
            (click)="sectionHidden.concreto = !sectionHidden.concreto"
          >
            <em class="fas fa-angle-up"></em>
          </button>

          <button
            type="button"
            *ngIf="sectionHidden.concreto"
            class="submitSearchButton"
            (click)="sectionHidden.concreto = !sectionHidden.concreto"
          >
            <em class="fas fa-angle-down"></em>
          </button>

          <div class="pageTitle collapsibleTitle">
            <div class="title halfTitle">Datos concretos</div>
          </div>
        </div>
      </div>

      <div *ngIf="!sectionHidden.concreto">
        <app-dynamic-fields
          #dynamicFields
          *ngIf="coc"
          [fields]="fields"
          [operation]="operation"
          (downloadFileEvent)="downloadFile($event)"
        ></app-dynamic-fields>
      </div>

      <div
        class="consultaEditarButtonGroup allWidth"
        *ngIf="
          operation == 'edit' ||
          (operation == 'detail' &&
            coc &&
            (coc.peEstado == 'PC' ||
              (coc.peEstado == 'AN' &&
                coc.peTcertificado == 'CM' &&
                isAnalystAnalystBasicAndAdvan &&
                (coc.usId == userIdConected ||
                  coc.analistaId == userIdConected))))
        "
      >
        <div style="margin-left: 19%">
          <div
            class="middleButtonAceptar mr-1"
            style="float: left"
            *ngIf="operation == 'edit'"
          >
            <button class="formButton" type="button" (click)="onSave()">
              {{ "commons.ok" | translate }}
            </button>
          </div>

          <div class="middleButtonAceptar" style="float: left">
            <button
              class="formButton"
              type="button"
              *ngIf="
                operation == 'detail' &&
                coc &&
                (coc.peEstado == 'PC' ||
                  (coc.peEstado == 'AN' &&
                    coc.peTcertificado == 'CM' &&
                    isAnalystAnalystBasicAndAdvan &&
                    (coc.usId == userIdConected ||
                      coc.analistaId == userIdConected)))
              "
              (click)="goEdit()"
            >
              {{ "commons.correct" | translate }}
            </button>

            <button
              class="formButton"
              type="button"
              *ngIf="operation == 'edit'"
              (click)="goDetail()"
            >
              {{ "commons.cancel" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="fullGroup">
      <div style="margin-bottom: 5px">
        <app-comments-history-peticion
          [id]="id"
        ></app-comments-history-peticion>
      </div>
    </div>

    <div class="fullGroup">
      <div style="margin-bottom: 5px">
        <app-compare-release-peticion
          [type]="'COC'"
          [id]="id"
          [isHistoric]="this.type == 'history'"
        ></app-compare-release-peticion>
      </div>
    </div>

    <div class="fullGroup" *ngIf="coc">
      <div style="margin-bottom: 5px">
        <app-list-related-requests
          [config]="config"
        ></app-list-related-requests>
      </div>
    </div>

    <div class="fullGroup" *ngIf="coc && coc.peEstado == 'AN'">
      <div style="margin-bottom: 5px">
        <app-reasigne-analyst
          [idPetition]="coc.peId"
          [analyst]="coc.analistaNombre"
          [peRelease]="coc.peRelease"
          (reasgine)="reasgine($event)"
        ></app-reasigne-analyst>
      </div>
    </div>

    <div class="consultaEditarButtonGroup">
      <div class="backButton">
        <button class="formButton" type="button" (click)="goList()">
          <em class="fas fa-chevron-left"></em>
        </button>
      </div>
    </div>
  </form>
</div>

<app-states
  *ngIf="coc && cocLoaded"
  [actualState]="coc.peEstado"
  [idPetition]="id"
  [release]="coc.peRelease"
  (reloadPetition)="reloadDetail($event)"
></app-states>
